<template>
  <div class="step">
    <div class="left">
      <div class="left-form">
        <div v-if="user">
          <h2>Ваш email подтвержден!</h2>
          <p>Спасибо за регистрацию</p>
        </div>
        <div v-else-if="emailToken">
          <h2>Ваш email проверятся подождите немного!</h2>
        </div>
        <div v-else>
          <h2>Подтвердите свою регистрацию</h2>
          <p>На ваш e-mail отправлено письмо
            с подтверждением регистрации</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {API_URL} from "../views/Register";
import api from "../api";
export default {
  name: "StepThree",
  data() {
    return {
      user: null
    }
  },
  computed: {
    emailToken(){
      return this.$route.params.emailtoken || null;
    }
  },
  methods: {
    goToPrevForm() {
      this.$emit('onNavToPrevForm');
    },
   async redirectToAdmin() {
      if(this.emailToken) {
        const response = (await api.confirmEmailToken(this.emailToken)).data;
        if(response && response.token) {
          this.user = response.token || null;
          localStorage.setItem("user", JSON.stringify(response));
          api.setJwtToken(response.token);
          setTimeout(()=> {
            window.location = `/admin2/`;
          },4000);
        } else {
          this.$message({ message: 'Не удалось подтвердить Ваш email', type: "error" });
        }
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.redirectToAdmin();
    });
  }
};
</script>

